import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import GameSceneRace from './GameSceneRace';

class StartFinishSign {

	gameSceneRace: GameSceneRace;
	
	screenObject;
	
	startPosition: THREE.Vector3;
	
	constructor(gameSceneRace: GameSceneRace) {
		this.gameSceneRace = gameSceneRace; 
		
		this.loading();
		
		this.screenObject = new THREE.Object3D();
		
		this.startPosition = this.screenObject.position; 
		
		this.gameSceneRace.sceneRootObject.add(this.screenObject);
		
	}
	/////////////////////////////////////////////////////////
	setStartPosition(x: number, y: number, z: number) {
		this.startPosition = new THREE.Vector3(x, y, z);
		this.screenObject.position.x = x;
		this.screenObject.position.y = y;
		this.screenObject.position.z = z;
	}
	/////////////////////////////////////////////////////////
	loading() {
		
		const loader = new GLTFLoader();
		loader.load('models/race_drag_start_and_finish_line.glb', (gltf) => {
			
			this.screenObject.add(gltf.scene);
		},
		(xhr) => {
			console.log('startFinish loading: ' + (xhr.loaded / xhr.total) * 100 + '% loaded');
		},
		(error) => {
			console.log('startFinish loading error! ' + error);
		});
	}
	/////////////////////////////////////////////////////////
	
}
export default StartFinishSign;